const header = [
  { text: 'Prizing Id', value: 'prizing_id' },
  { text: 'Name', value: 'name' },
  { text: 'Weight', value: 'weight' },
  { text: 'Is Boosted', value: 'is_boosted' },
  { text: 'Action', value: 'actions', sortable: false }
]

export default header
